import React from 'react';
import { JobsiteSchedulesContextType } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';

export const JobsiteSchedulesContext =
  React.createContext<JobsiteSchedulesContextType | null>(null);
